module.exports = __webpack_public_path__ + "catalog/items/fire-extinguisher/label-image.png";